import { render } from "./Carica.vue?vue&type=template&id=4152e4d9&scoped=true"
import script from "./Carica.vue?vue&type=script&lang=js"
export * from "./Carica.vue?vue&type=script&lang=js"

import "./Carica.vue?vue&type=style&index=0&id=4152e4d9&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4152e4d9"]])

export default __exports__